import { ProductTypes } from '../../../../../types';
import {
  P100ProPastActivitiesQuestions,
  optionalP100ProQuestions,
  prime100ProQuestions,
} from './prime100ProQuestionSchema';
import {
  primeOneBaseQuestions,
  primeOneMediaQuestions,
  primeOnePastActivitiesQuestions,
} from './primeOneQuestionSchema';
import {
  primeTechBaseQuestions,
  primeTechCyberCrimeQuestions,
  primeTechMediaQuestions,
  primeTechPastActivitiesQuestions,
} from './primeTechQuestionSchema';

export const securityQuestions = Object.freeze({
  [ProductTypes.p100_pro]: {
    'Security Assessment': prime100ProQuestions,
    'Past Activities': P100ProPastActivitiesQuestions,
    'Optional Security Assessment Questions': optionalP100ProQuestions,
  },
  [ProductTypes.prime_one]: {
    'Security Assessment': primeOneBaseQuestions,
    'Media Questions': primeOneMediaQuestions,
    'Past Activities': primeOnePastActivitiesQuestions,
  },
  [ProductTypes.prime_tech]: {
    'Security Assessment': primeTechBaseQuestions,
    'Cyber Crime': primeTechCyberCrimeQuestions,
    'Media Questions': primeTechMediaQuestions,
    'Past Activities': primeTechPastActivitiesQuestions,
  },
  [ProductTypes.prime_one_tech]: {},
});

export type ProductTypes = keyof typeof securityQuestions;
